import { cn } from "@/lib/utils";

interface BdayLogoProps {
  className?: string;
  size?: number;
  "aria-hidden"?: boolean;
}

// Aspect ratio of /logo.png (378×62 — clock icon + "BirthdayAlarm" wordmark).
const LOGO_ASPECT = 378 / 62;

export function BdayLogo({ className, size = 28, "aria-hidden": ariaHidden }: BdayLogoProps) {
  return (
    <img
      src="/logo.png"
      alt={ariaHidden ? "" : "BirthdayAlarm"}
      aria-hidden={ariaHidden}
      width={Math.round(size * LOGO_ASPECT)}
      height={size}
      className={cn("inline-block select-none", className)}
      style={{ height: size, width: "auto" }}
    />
  );
}
